import {DataTableColumn} from 'mantine-datatable';
import {NavLink} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {Product} from '../types';
import {ProductStatusBadge} from '../profile/Badges';
import config from '../config';

export const useProductsTableColumns = () => {

    // Every column is sortable: the header is clickable and sorts through
    // useTableSort in useProducts. Dates, text and the unit count all order
    // correctly with the shared comparator (numbers numerically).
    const columns: DataTableColumn<Product>[] = [
        {
            accessor: 'name',
            sortable: true,
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: Product) => (
                <NavLink to={`${config.basePath}/${encodeURIComponent(item.id)}`}>{item.name}</NavLink>
            ),
        },
        {
            accessor: 'summary',
            sortable: true,
            title: I18n.get('Summary'),
            width: '2fr',
        },
        {
            // A path accessor: sortRecords reads `dimensions.length` as a number.
            accessor: 'dimensions.length',
            sortable: true,
            title: I18n.get('Pricing units'),
            width: '140px',
            textAlign: 'right',
            render: (item: Product) => item.dimensions.length,
        },
        {
            accessor: 'status',
            sortable: true,
            title: I18n.get('Status'),
            width: '120px',
            render: (item: Product) => <ProductStatusBadge status={item.status}/>,
        },
        {
            accessor: 'created',
            sortable: true,
            title: I18n.get('Created'),
            width: '190px',
            render: (item: Product) => formatTimestamp(item.created),
        },
        {
            accessor: 'updated',
            sortable: true,
            title: I18n.get('Updated'),
            width: '190px',
            render: (item: Product) => formatTimestamp(item.updated),
        },
    ];

    return {
        columns,
    };
};
